import tw, { css, styled } from 'twin.macro'

import { Link } from 'gatsby'
import { animated, useSpring } from 'react-spring'

export const HeroSection = styled.section`
	${tw`flex flex-col w-full items-center bg-center bg-no-repeat bg-cover relative overflow-hidden`}
	background-image: url(${({ sources }) => sources[0].base64});

	@media (min-width: 320px) {
		height: 230px;
		max-height: 230px;
	}

	@media (min-width: 525px) {
		height: 320px;
		max-height: 320px;
	}

	@media (min-width: 768px) {
		height: 440px;
		max-height: 440px;
	}

	@media (min-width: 1024px) {
		height: 580px;
		max-height: 580px;
	}
	@media (min-width: 1280px) {
		height: 600px;
		max-height: 600px;
	}
`
export const HeroItemsContainer = styled.div`
	${tw`absolute flex flex-col w-full m-auto items-center justify-center h-full pb-4 pt-8 lg:p-0`}
	top:0;
	left: 0;
	right: 0;

	> svg {
		@media(min-width: 525px) {
			${tw`w-8/12`}
		}
		${tw`w-7/12 md:w-auto`}
	}

	> svg#ecoclear-swim-logo {
		filter: drop-shadow(1px 4px 4px rgba(0,0,0,0.625));
	}

	${tw`bg-cover bg-no-repeat bg-center`}
	@media (min-width: 1350px) {
		${tw`bg-bottom`}
		background-image: url(${({ sources }) => (sources ? sources[0].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[0].src : '')});
	}
  	@media (min-width: 1280px) and (max-width: 1349px) {
		background-image: url(${({ sources }) => (sources ? sources[1].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[1].src : '')});
	}
	@media (min-width: 1024px) and (max-width: 1279px) {
		background-image: url(${({ sources }) => (sources ? sources[2].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[2].src : '')});
	}
	@media (min-width: 768px) and (max-width: 1023px) {
		background-image: url(${({ sources }) => (sources ? sources[3].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[3].src : '')});
	}
	@media (max-width: 767px) {
		background-image: url(${({ sources }) => (sources ? sources[4].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[4].src : '')});
	}
`
export const HeroTitle = styled.h1`
	${tw`text-4xl sm:text-5xl uppercase font-display text-white font-bold tracking-wider`}
	text-shadow: 3px 3px 8px rgba(0,0,0,.75);
`

export const TestimonialSection = tw.section`w-full`
export const TestimonialContainer = tw.div`w-full flex flex-row flex-wrap mt-8 sm:-mt-20 relative z-10`
export const Testimonial = tw.div`shadow-xl bg-white p-4`
export const TestimonialHolder = styled.div`
	${tw`w-full sm:w-6/12 lg:w-4/12 mb-8`}

	&:nth-of-type(3n + 1) {
		${tw`pl-8 lg:pl-16 pr-8`}
	}
	&:nth-of-type(3n + 2) {
		${tw`px-8`}
	}
	&:nth-of-type(3n + 3) {
		${tw`pl-8 pr-8 lg:pr-16`}
	}
`
export const Paragraph = styled.p`
	${tw`text-sm font-display leading-snug mb-3`}

	> span {
		${tw`text-blue-500 underline hover:no-underline cursor-pointer`}
	}
`
export const ParagraphContainer = styled.div`
	${tw`overflow-hidden`}
	height: 100px;
`
export const AnimatedParagraphContainer = animated(ParagraphContainer)
export const Author = tw.p`text-center text-sm text-blue-500 font-bold mb-1`
export const Desc = tw.p`text-center text-xs`

export const EndBannerSection = styled.section`
	background: url('${({ bg }) => (bg ? bg : '')}');
	${tw`flex flex-col w-full items-center bg-center bg-no-repeat bg-cover relative overflow-hidden mb-8`}

	@media (min-width: 320px) {
		height: 230px;
		max-height: 230px;
	}

	@media (min-width: 525px) {
		height: 320px;
		max-height: 320px;
	}

	@media (min-width: 768px) {
		height: 350px;
		max-height: 350px;
	}

	@media (min-width: 1280px) {
		height: 400px;
		max-height: 400px;
	}
`
export const EndBannerContainer = styled.div`
	${tw`w-full flex flex-col items-center justify-center h-full`}

	> svg {
		${tw`w-64 sm:w-6/12 md:w-auto`}
	}
`
export const Hook = tw.p`text-3xl md:text-4xl font-display text-white mt-4 md:mt-8 mb-4 md:mb-12 font-bold text-center px-4 md:px-0`
export const LearnMore = styled(Link)`
	${tw`font-display text-white py-2 md:py-3 px-6 md:px-10 uppercase text-lg border-2 border-white rounded hover:text-blue-500 hover:bg-white`}
`
